import axios from "@/plugins/axios";

let url = "/api/console/setting";

export default {
    getSetting(){
        return axios.get(url).then(result => result.data);
    },
    putSetting(data){
        return axios.put(url, data).then(result => result.data);
    },
    // 킬스위치 { killSwitch: { charge, exchange }, targets }
    getKillSwitch(){
        return axios.get(`${url}/kill-switch`).then(result => result.data);
    },
    // { target: "charge" | "exchange", blocked: boolean, message }
    putKillSwitch(data){
        return axios.put(`${url}/kill-switch`, data).then(result => result.data);
    }
}
